<template>
    <div class="d-flex align-items-stretch">
        <parens left />
        <div
            v-bind:class="{ 'flex-column': wrap }"
            class="d-flex align-items-center">
            <div ref="left">
                {{ choiceReference }}
            </div>
            <div v-bind:class="operatorClassName">
                {{ operator }}
            </div>
            <div
                ref="right"
                class="fst-italic fw-bold">
                {{ listItem }}
            </div>
        </div>
        <parens />
    </div>
</template>
<script>
    import base from "./_baseExpression.vue";
    import { EXPRESSION_TYPES } from "../../expressionTypes";
    import displayReference from "./_displayReferenceMixin.js";

    import { isModuleRegistered } from "SharedStores/util";
    import { PROGRAM_TYPES, PROGRAM_NAMESPACE } from "SharedStores/Program/programStore";

    export default {
        extends: base,
        mixins: [displayReference],
        computed: {
            operator() {
                if (this.expression.Type === EXPRESSION_TYPES.ChoiceEqual) {
                    return "=";
                }
                return "\u2260";
            },
            choiceReference() {
                let valueOverride = " "; //use space to force usage
                if (this.expression.evalResult && this.expression.evalResult.metadata) {
                    valueOverride = this.expression.evalResult.metadata.projectValue || " ";
                }
                return this.getReferenceDisplay(valueOverride);
            },
            listItem() {
                if (this.expression.ListItemDefinitionId) {
                    if (!isModuleRegistered(PROGRAM_NAMESPACE, this.$store.state)) {
                        throw Error("program store not registered");
                    }
                    const listItem = this.$store.getters[PROGRAM_TYPES.getters.listItemFromId](
                        this.expression.ListItemDefinitionId.toString()
                    );
                    return listItem.Value;
                }
                return "Choice";
            }
        },
        methods: {
            wrapGainOverride() {
                let leftWidth = 1;
                let rightWidth = 1;

                if (this.$refs.left && this.$refs.right) {
                    leftWidth = Math.ceil(this.$refs.left.getBoundingClientRect().width);
                    rightWidth = Math.ceil(this.$refs.right.getBoundingClientRect().width);
                }
                return this.width() - Math.max(leftWidth, rightWidth);
            }
        }
    };
</script>
